<template>
    <v-layout row wrap>                                    
        <v-flex xs12 lg10 offset-lg1>                                                
            <formFiltro/>
            <facturasPendientes/>
            <buttonLaunchReport v-if="$store.state.appconfig.autoventa"/>
        </v-flex>
        <dialogTipoCobro/> 
        <dialogInformeComerciales v-if="$store.state.appconfig.autoventa"/>                    
    </v-layout>    
</template>
<script>
import formFiltro from '@/components/formFiltroDocumentos'
import facturasPendientes from '@/components/facturasPendientes'
import dialogTipoCobro from '@/components/dialogTipoCobro'
import dialogInformeComerciales from '@/components/dialogInformeComerciales'
import buttonLaunchReport from '@/components/buttonLaunchReport'
import store from '@/store'


export default {
    name: 'VistaFacturas',
    components:{
        formFiltro,
        facturasPendientes,
        dialogTipoCobro,
        dialogInformeComerciales,
        buttonLaunchReport
    } ,
    beforeRouteLeave (to, from, next) {      
        store.state.docNameVisible = true;
        next()    
    },
    beforeRouteEnter (to, from, next) {
        store.state.docNameVisible = false;
        next(vm => {
            // access to component instance via `vm`
        })
    },
    mounted(){
        this.checkSession();
    }
}

</script>

